import React from 'react';
import { motion } from 'framer-motion';

export const PhoneFrame: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <motion.div
      className="relative mx-auto"
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <div className="relative mx-auto border-gray-800 dark:border-gray-800 bg-gray-800 border-[14px] rounded-[2.5rem] h-[680px] w-[320px] shadow-xl">
        <div className="h-[32px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -left-[17px] top-[72px] rounded-l-lg"></div>
        <div className="h-[46px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -left-[17px] top-[124px] rounded-l-lg"></div>
        <div className="h-[46px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -left-[17px] top-[178px] rounded-l-lg"></div>
        <div className="h-[64px] w-[3px] bg-gray-800 dark:bg-gray-800 absolute -right-[17px] top-[142px] rounded-r-lg"></div>
        <div className="rounded-[2rem] overflow-hidden w-[292px] h-[652px] bg-white dark:bg-gray-800">
          <div className="h-[32px] w-[32px] bg-gray-800 dark:bg-gray-800 absolute top-0 left-1/2 -translate-x-1/2 rounded-b-[1rem] flex items-center justify-center">
            <div className="h-[8px] w-[8px] bg-gray-800 dark:bg-gray-800 rounded-full absolute top-[10px] left-1/2 -translate-x-1/2"></div>
          </div>
          {children}
        </div>
      </div>
      
      <div className="relative">
        <div className="absolute -bottom-5 inset-x-0 h-[50px] bg-gradient-to-t from-black/20 to-transparent blur-xl"></div>
      </div>
    </motion.div>
  );
};